import { execAdmin } from '../utils';

interface CancelCatalogUploadVariables {
  catalogUploadId: number;
}

interface CancelCatalogUploadResponse {
  cancelCatalogUpload: {
    result: boolean;
  };
}

const CANCEL_CATALOG_UPLOAD_MUTATION = `
  mutation cancelCatalogUpload($catalogUploadId: Int) {
    cancelCatalogUpload(catalogUploadId: $catalogUploadId) {
      result
    }
  }
`;

export const cancelCatalogUpload = async (
  catalogUploadId: number,
): Promise<boolean> => {
  const data = await execAdmin<CancelCatalogUploadVariables, CancelCatalogUploadResponse>(
    CANCEL_CATALOG_UPLOAD_MUTATION,
    { variables: { catalogUploadId } },
  );
  return data.cancelCatalogUpload.result;
};
